import { render, staticRenderFns } from "./AffiliateChangeHistoryItem.vue?vue&type=template&id=1af96718&"
import script from "./AffiliateChangeHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./AffiliateChangeHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./AffiliateChangeHistoryItem.vue?vue&type=style&index=0&id=1af96718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports